module.exports = __webpack_public_path__ + "img/user14.467f2228.jpg";